
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { StoriesRow } from "@/components/stories/StoriesRow";
import { SuggestedFollows } from "@/components/suggested/SuggestedFollows";
import { CreatePost } from "@/components/feed/CreatePost";
import { PostsList } from "@/components/feed/PostsList";
import { FeedHeader } from "@/components/feed/FeedHeader";

const Feed = () => {
  const { user } = useAuth();
  const isMobile = useIsMobile();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="min-h-screen w-full max-w-5xl mx-auto"
    >
      <div className="flex gap-6">
        <div className="flex-1 max-w-2xl">
          <FeedHeader />
          <StoriesRow />

          <div className="divide-y divide-flux-cyan/10">
            {user && <CreatePost />}
            <PostsList />
          </div>
        </div>

        {!isMobile && (
          <div className="hidden lg:block w-80 sticky top-20 h-fit">
            <SuggestedFollows />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default Feed;
